import {Pipe, PipeTransform} from '@angular/core';
import {Shipment} from '../../domain/shipment';

@Pipe({
    name: 'shipmentStatusName',
    standalone: false
})
export class ShipmentStatusNamePipe implements PipeTransform {
  transform(shipment: Shipment): string {
    if (shipment.Status == 'Finished') {
      return 'Fullført'
    }

    switch (shipment.OrderStatus) {
      case 'Unassigned':
        return 'Ikke tildelt';
      case 'Offer':
        return 'Tildelt';
      case 'Accepted':
        return 'Akseptert'
      case 'Rejected':
        return 'Avvist';
      case 'Started':
        return 'Påbegynt';
      case 'Finished':
        return 'Fullført';
      case 'Expired':
      case 'Registered':
      case null:
        return 'Ikke påbegynt';
      default:
        return shipment.OrderStatus;
    }
  }
}
